<template>
  <HgLoadWhenInViewport>
    <img
      :class="[
        !imagePathCorrect ? $style.imagePathIncorrect : '',
        $style.logo,
        big ? $style.logoBig : '',
      ]"
      :src="imageSrc"
      @error="imagePathCorrect = false"
    />
  </HgLoadWhenInViewport>
</template>

<script lang="ts" setup>
import { HgLoadWhenInViewport } from '@smg-real-estate/domus';
import { ref } from 'vue';

defineOptions({
  name: 'ListItemLogo',
});

interface Props {
  imageSrc: string;
  big?: boolean;
}
defineProps<Props>();

const imagePathCorrect = ref(true);
</script>

<style lang="scss" module>
@import '@/assets/variables';

$list-item-logo-max-width-small: 84px;
$list-item-logo-max-height-small: 28px;
$list-item-logo-max-width-medium: 120px;
$list-item-logo-max-height-medium: 40px;

img.logo {
  max-width: $list-item-logo-max-width-small;
  max-height: $list-item-logo-max-height-small;

  @media (min-width: $viewport-medium-min) {
    &.logoBig {
      top: 0.3rem;
      max-width: 120px;
      max-height: 40px;
    }
  }
}

.imagePathIncorrect {
  display: none;
}
</style>
